

@if (!hasData) {
  <div id="add-family-gap">
    <h4 class="mb-10" [innerHTML]="question?.question_copy"></h4>
    <div class="button-box">
      <a href="#mini-form-modal" data-toggle="modal" class="button button--primary" [innerHTML]="question?.question_prompt"></a>
    </div>
  </div>
}

@if (hasData) {
  <div id="family-gap-members">
    <h4 class="mb-10" [innerHTML]="question?.question_copy"></h4>
    @for (item of itemsData; track item) {
      <div class="person-box">
        <div class="person-box__detail">
          <div class="person-box__name">{{getParameter(item,'heading')}} </div>
          <ul class="person-box__info">
            <li>{{getParameter(item,'detail')}}</li>
            <li></li>
          </ul>
        </div>
        <div class="person-box__actions">
          @if (item?.delete) {
            <a href="#" (click)="deleteItem(item)" data-toggle="modal" class="icon-hover icon-hover--flush"
              data-tooltip="tooltip" data-placement="top" title="Remove"><svg
              class="icon">
              <use xlink:href="#trash-bin"></use>
            </svg></a>
          }
          @if (item?.edit) {
            <a href="#mini-form-modal" (click)="editItem(item)" data-toggle="modal" class="icon-hover icon-hover--flush" data-tooltip="tooltip"
              data-placement="top" title="Edit"><svg class="icon">
              <use xlink:href="#edit-underline"></use>
            </svg></a>
          }
        </div>
      </div>
    }
    <div class="mt-20">
      <a href="#mini-form-modal" (click)="addAnother()" data-toggle="modal" class="button-control">
        <svg class="icon">
          <use xlink:href="#plus-filled"></use>
          </svg><strong>Add another</strong>
        </a>
      </div>
    </div>
  }
  <hr class="hr--xs" />




